<template>
  <div class="card">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="解锁展厅" name="first" v-if="userMess.applyPost!==2">
        <m-table :column="column" :table-data="tableData" :total="total" @get-list="getList"></m-table>
      </el-tab-pane>
      <el-tab-pane label="退出报名" name="second">
        <ul class="btn-tag">
          <li v-for="item in officeType" @click="btnClick(item.value)" :class="[activityType==item.value?'active':'']">{{item.label}}</li>
        </ul>
        <!-- <el-button size="medium" round v-for="item in officeType" @click="btnClick(item.value)">{{item.label}}</el-button> -->
        <!-- <el-button-group>
          <el-button type="primary" v-for="item in officeType" @click="btnClick(item.value)">{{item.label}}</el-button>
        </el-button-group> -->
        <m-table :column="column" :table-data="tableData" :total="total" @get-list="getList"></m-table>
      </el-tab-pane>
      <el-tab-pane label="保留资格" name="third">
        <template v-if="!integralDetail">
          <div class="no-data">
            <img src="@images/none.png" />
            <div>暂无数据</div>
          </div>
        </template>
        <template v-else>
          <div style="border-bottom:1px solid #E6E6E6;padding:10px 20px 20px 20px">
            <div class="flex-s-c">
              <div class="flex-s-c">
                <!-- 1审核中 2驳回 3已通过  -->
                <template v-if="integralDetail.status==0">
                  <i class="iconfont icon-shenhezhong status-iconfont"></i>
                  <span class="status-text">未审核</span>
                </template>
                <template v-if="integralDetail.status==2">
                  <i class="iconfont icon-yiwancheng status-iconfont"></i>
                  <span class="status-text">通过</span>
                </template>
                <template v-if="integralDetail.status==1">
                  <i class="iconfont icon-weiwanchengrenwushu status-iconfont"></i>
                  <span class="status-text">已驳回</span>
                </template>
              </div>
              <div style="text-align: center;margin-left:60px">
                <div class="fontcolor-grey ">申请时间：{{integralDetail.applyTime}}</div>
              </div>
            </div>
          </div>
          <div class="title-border">
            <span class="name">活动详情</span>
          </div>
          <ul class="key-value">
            <li v-for="item in messageList">
              <div class="key">{{item.key}}：</div>
              <div class="value">{{item.value}}</div>
            </li>
          </ul>
          <div class="title-border">
            <span class="name">审核信息</span>
          </div>
          <ul class="key-value">
            <li v-for="item in examineList">
              <div class="key">{{item.key}}：</div>
              <div class="value">{{item.value}}</div>
            </li>
          </ul>
        </template>

        <!-- <m-table :column="column" :table-data="tableData" :total="400" @get-list="getList"></m-table> -->
      </el-tab-pane>

    </el-tabs>
  </div>
</template>

<script>
import mTable from './components/table.vue'
export default {
  components: {
    mTable
  },
  data() {
    return {
      activeName: "first",
      column: [],
      tableData: [],
      total: 0,
      officeType: [{ label: "讲解", value: "1" }, { label: "服务", value: "2" }, { label: "策划", value: "3" }, { label: "其他活动", value: "4" },],
      messageList: [
        { key: "年度", value: "010-09-22 09:20:09" },
        { key: "积分", value: "23131233" },
      ],
      examineList: [
        { key: "审核时间", value: "2010-10-10" },
        { key: "审核结果", value: "12人" },
      ],
      activityType: 1,
      integralDetail: {},
      userMess: this.$store.state.user.user
    };
  },
  computed: {},
  watch: {
    activeName() {
      // console.log(this.activeName)
      this.getColumn(this.activeName);

    }
  },
  methods: {
    //
    getList(obj) {
      // console.log(params)
      let active = this.activeName
      // console.log(active)
      if (active == "first") {
        let params = {
          pageNumber: obj.currentPage,
          pageSize: obj.pageSize,
          volunteerId: this.userMess.id
        }
        this.$api.getExhibitionApplication(params).then(res => {
          // console.log(res)
          this.tableData = res.data.rows
          this.total = res.data.total
        })
      } else if (active == "second") {
        let params = {
          activityType: this.activityType,
          pageNumber: obj.currentPage,
          pageSize: obj.pageSize,
          volunteerId: this.userMess.id
        }
        this.$api.getCancelApplication(params).then(res => {
          this.tableData = res.data.rows.map(item => {
            let activityTypeStr
            if (item.activityType == 1) activityTypeStr = "讲解"
            else if (item.activityType == 2) activityTypeStr = "服务"
            else if (item.activityType == 3) activityTypeStr = "策划"
            else if (item.activityType == 4) activityTypeStr = "其他活动 "
            return { ...item, activityTypeStr: activityTypeStr }
          })
          this.total = res.data.total
        })
      }
    },
    //获取保留资格
    getHold() {
      this.$api.getIntegralResultDetail({ volunteerId: this.userMess.id }).then(res => {

        this.integralDetail = res.data
        if (res.data) {
          console.log(res)
          this.messageList = [
            { key: "年度", value: res.data.yearSelect + '年' },
            { key: "积分", value: res.data.totalIntegral + '分' },
          ]
          let status
          //  0未审核  1审核不通过  2审核通过
          if (res.data.status == 0) status = "未审核"
          else if (res.data.status == 1) status = "已驳回"
          else if (res.data.status == 2) status = "通过"
          this.examineList = [
            { key: "审核时间", value: res.data.auditTime ? res.data.auditTime : '暂无' },
            { key: "审核结果", value: status },
          ]
        }
      })
    },
    //获取表头
    getColumn(type) {
      let val = type
      if (val == "first") {
        this.column = [
          { prop: "exhibitionName", label: "展厅名称", width: "" },
          { prop: "createTime", label: "申请时间", width: "" },
          { prop: "exhibitionTypeName", label: "展厅类型", width: "" },
        ]
      } else if (val == "second") {
        if (this.activityType == 1) {
          this.column = [{ prop: "exhibitionHallName", label: "展厅名称", width: "" }]
        } else if (this.activityType == 2) {
          this.column = [{ prop: "serviceStartTime", label: "服务日期", width: "" }]
        }
        this.column.push(
          { prop: "cancelTime", label: "申请时间", width: "" },
          { prop: "activityTypeStr", label: "类型", width: "" },
        )
      }
    },
    //改变tabs
    handleClick(tab, event) {
      let params = { currentPage: 1, pageSize: 10 }
      this.getList(params);
      // console.log(tab);
    },
    //退出报名 切换志愿者类型
    btnClick(val) {
      let params = { currentPage: 1, pageSize: 10 }
      this.activityType = val
      this.getList(params);
      // 讲解对应展厅名称，服务对应服务日期，策划/活动对应活动名称
      if (this.activityType == 1) {
        this.column = [{ prop: "exhibitionHallName", label: "展厅名称", width: "" }]
      } else if (this.activityType == 2) {
        this.column = [{ prop: "serviceStartTime", label: "服务日期", width: "" }]
      } else if (this.activityType == 3 || this.activityType == 4) {
        this.column = [{ prop: "activityName", label: "活动名称", width: "" }]
      }
      this.column.push(
        { prop: "cancelTime", label: "申请时间", width: "" },
        { prop: "activityTypeStr", label: "类型", width: "" },
      )
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() { },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    let params = { currentPage: 1, pageSize: 10 }

    if (this.userMess.applyPost == 1) {
      this.officeType = [{ label: "讲解", value: "1" }, { label: "服务", value: "2" }, { label: "其他活动", value: "4" }]
      this.activityType = 1
    } else if (this.userMess.applyPost == 2) {
      this.activeName = "second"
      this.activityType = 2
      this.officeType = [{ label: "服务", value: "2" }, { label: "其他活动", value: "4" }]
    } else if (this.userMess.applyPost == 3) {
      this.activityType = 1
      this.officeType = [{ label: "讲解", value: "1" }, { label: "服务", value: "2" }, { label: "策划", value: "3" }, { label: "其他活动", value: "4" }]
    }
    this.getColumn(this.activeName);
    this.getList(params);
    this.getHold()

  },
  beforeCreate() { }, //生命周期 - 创建之前
  beforeMount() { }, //生命周期 - 挂载之前
  beforeUpdate() { }, //生命周期 - 更新之前
  updated() { }, //生命周期 - 更新之后
  beforeDestroy() { }, //生命周期 - 销毁之前
  destroyed() { }, //生命周期 - 销毁完成
  activated() { } //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang="less" scoped>
.btn-tag {
  display: flex;
  li {
    display: inline-block;
    line-height: 1;
    white-space: nowrap;
    cursor: pointer;
    background: #fff;
    border: 1px solid #dcdfe6;
    color: #606266;
    -webkit-appearance: none;
    text-align: center;
    box-sizing: border-box;
    outline: 0;
    margin: 0;
    transition: 0.1s;
    font-weight: 500;
    padding: 12px 20px;
    font-size: 14px;
    border-radius: 0;
    border-right: 0;
  }
  li.active {
    color: #fff;
    background-color: #007083;
    border-color: #007083;
  }
  li:last-child {
    border-right: 1px solid #dcdfe6;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
  }
  li:first-child {
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
  }
}
</style>
